import request from '@/utils/request'

/**
 * 查询商品导入批次列表
 * @param {Object} params 查询参数：page/row/shopId(可选)
 * @returns {Promise} records=总页数 total=总记录数 list=批次列表
 */
export function queryImportBatches(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/importBatch.queryImportBatches',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品导入批次明细
 * @param {Object} params 查询参数：logId/page/row/state(可选)
 * @returns {Promise} {details:{records,total,list}, stateDist:{W,C,F,S}}
 */
export function queryImportBatchDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/importBatch.queryImportBatchDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 批量审核商品（导入批次场景）
 * @param {Object} data {productIds: [], auditState, auditOpinion}
 * @returns {Promise}
 */
export function batchAuditProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.batchAuditProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 按导入批次整批下架商品
 * @param {Object} data {importLogId, shopId}
 * @returns {Promise}
 */
export function batchOffShelfByImport(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.batchOffShelfByImport',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
